var _circle, _circle2, _circle3, _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultProfileImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 153,
    viewBox: "0 0 152 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.8418,
    cy: 76.625,
    r: 70,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.8418,
    cy: 76.6227,
    r: 74.6891,
    fill: "white",
    stroke: "#EEEEEE",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8455_31651",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 141,
    height: 141
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.8418,
    cy: 76.625,
    r: 70,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8455_31651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.99 192.745C146.398 190.662 138.327 187.277 134.162 185.194C139.369 204.2 146.659 231.278 149.783 238.568C153.949 248.982 158.896 254.97 159.416 259.917C159.416 260.698 159.416 261.479 159.416 262.26C158.115 267.988 115.676 312.509 89.1196 308.604C62.563 304.699 54.4919 293.503 54.4919 293.503L34.9651 196.65C33.9236 201.597 33.4029 206.023 33.4029 210.189C32.3615 210.449 31.5804 210.97 30.539 211.23C16.4796 216.698 5.02386 228.414 -1.22474 235.443C-4.34904 228.414 -6.17155 220.082 -5.91119 210.97C-4.86976 164.626 28.7165 128.176 50.8469 115.679C54.2316 113.856 57.3559 112.294 59.9595 111.773C60.2198 114.116 60.7405 116.72 60.4802 118.022C60.4802 118.803 61.2612 119.584 62.563 120.625C66.9891 123.489 77.4035 125.833 82.871 123.229C84.6935 122.188 86.2556 121.406 87.0367 120.365C89.6403 117.761 88.8592 115.679 88.3385 113.856C88.0781 113.075 87.5574 112.034 87.2971 110.992C90.161 110.992 93.2853 111.253 96.1493 111.513C111.771 113.596 128.694 120.365 142.753 131.56C152.126 138.851 159.677 143.537 166.446 146.401C167.748 158.377 164.884 169.833 161.499 178.946C159.416 184.934 156.813 189.62 154.99 192.745Z",
    fill: "#30C671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.315 65.1687C97.1906 66.4705 94.8473 66.4705 93.0248 65.9498C90.6816 65.4291 89.3798 64.1273 89.3798 64.1273C79.2258 68.293 74.0187 62.3048 74.0187 62.3048C74.0187 62.3048 71.4151 70.3759 59.699 68.293C58.6576 76.8848 49.545 79.4884 49.545 79.4884C42.255 76.6245 41.7343 82.3524 43.2964 88.0802C44.8586 93.8081 49.8054 90.4235 50.3261 91.7252C50.8468 93.027 51.8882 100.838 51.8882 100.838C51.8882 100.838 42.5153 102.921 38.0893 97.4531C33.6632 91.9856 37.5685 85.2163 37.5685 85.2163C37.5685 85.2163 30.2785 85.4767 27.6749 72.4587C25.0713 59.4408 33.6632 55.7958 33.6632 55.7958C33.6632 55.7958 27.4146 39.1329 38.0893 33.1446C48.5036 26.896 59.4386 35.2275 59.4386 35.2275C59.4386 35.2275 62.8233 27.1564 74.5394 26.115C86.2555 25.0735 89.9005 37.05 89.9005 37.05C110.469 32.6239 107.345 62.3048 100.315 65.1687Z",
    fill: "#2C294F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7527 91.7252C98.232 96.4116 93.5455 101.879 86.7762 105.524C79.2258 109.69 68.8115 111.252 59.1782 106.305C57.8764 105.524 56.5747 104.743 55.2729 103.962C53.9711 103.181 52.9296 102.139 51.6278 100.838C51.6278 100.838 50.5864 93.027 50.0657 91.7252C49.545 90.4234 44.5982 93.808 43.036 88.0802C41.4739 82.3523 41.9946 76.8847 49.2846 79.4883C49.2846 79.4883 58.3972 76.6244 59.4386 68.2929C71.1547 70.3758 73.7583 62.3047 73.7583 62.3047C73.7583 62.3047 78.9655 68.2929 89.1194 64.1272C89.1194 64.1272 90.4212 65.429 92.7645 65.9497C92.7645 65.9497 94.0662 68.5533 95.6284 72.719C97.4509 77.9262 99.5338 85.2162 98.7527 91.7252Z",
    fill: "url(#paint0_linear_8455_31651)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.297 120.106C86.2556 121.148 84.9538 121.929 83.1313 122.97C77.9241 125.574 68.5512 123.491 63.6044 120.887C63.3441 120.627 63.0837 120.627 62.563 120.366C61.2612 119.585 60.4801 118.544 60.4801 117.763C60.4801 116.461 60.2198 114.118 59.9594 111.514C59.699 109.692 59.1783 107.609 58.918 106.047C68.8116 110.994 78.9656 109.431 86.5159 105.266C86.5159 106.828 86.5159 108.13 86.7763 109.171C86.7763 109.692 87.0367 110.212 87.0367 110.473C87.5574 111.775 87.8177 112.556 88.0781 113.337C89.1195 115.42 89.6403 117.763 87.297 120.106Z",
    fill: "url(#paint1_linear_8455_31651)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8416 82.0905C75.8416 83.6526 74.8002 84.9545 73.7588 84.9545C72.7173 84.9545 71.6759 83.6526 71.6759 82.0905C71.6759 80.5283 72.7173 79.2266 73.7588 79.2266C74.8002 79.2266 75.8416 80.7887 75.8416 82.0905Z",
    fill: "#2C294F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6398 79.4889C89.6398 81.0511 88.5984 82.3529 87.557 82.3529C86.2552 82.3529 85.4741 81.0511 85.4741 79.4889C85.4741 77.9268 86.5156 76.625 87.557 76.625C88.5984 76.625 89.6398 77.9268 89.6398 79.4889Z",
    fill: "#2C294F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7286 91.4648L87.2969 93.027C87.2969 93.027 82.6105 101.098 75.0601 100.577C69.5926 100.057 66.7286 91.4648 66.7286 91.4648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M95.6285 72.719C75.0602 63.6065 56.054 77.4055 53.7108 82.873C51.628 88.0802 53.9712 99.5359 55.0126 103.962C53.7108 103.181 52.6694 102.139 51.3676 100.838C51.3676 100.838 50.3262 93.027 49.8054 91.7252C49.2847 90.4234 44.3379 93.808 42.7758 88.0802C41.2136 82.3523 41.7343 76.8847 49.0244 79.4883C49.0244 79.4883 58.1369 76.6244 59.1783 68.2929C70.8945 70.3758 73.498 62.3047 73.498 62.3047C73.498 62.3047 78.7052 68.2929 88.8592 64.1272C88.8592 64.1272 90.161 65.429 92.5042 65.9497C92.7646 65.9497 94.3267 68.5533 95.6285 72.719Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M87.0366 109.429C80.5277 111.512 69.853 115.417 63.6044 121.145C63.3441 120.885 63.0837 120.885 62.563 120.624C61.2612 119.843 60.4801 118.802 60.4801 118.021C60.4801 116.719 60.2198 114.376 59.9594 111.772C59.699 109.95 59.1783 107.867 58.918 106.305C68.8116 111.251 78.9656 109.689 86.5159 105.523C86.7763 107.086 86.7763 108.387 87.0366 109.429Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M84.4339 133.124C64.3863 134.686 54.4927 121.929 50.8477 115.94C54.2323 114.118 57.3566 112.556 59.9602 112.035C60.2206 114.378 60.7413 116.982 60.4809 118.284C60.4809 119.065 61.262 119.846 62.5638 120.887C66.9899 123.751 77.4042 126.094 82.8717 123.491C84.6942 122.449 86.2564 121.668 87.0374 120.627C89.641 118.023 88.86 115.94 88.3392 114.118C88.0789 113.337 87.5582 112.295 87.2978 111.254C90.1618 111.254 93.286 111.514 96.15 111.775C98.7536 121.148 98.2329 131.822 84.4339 133.124Z",
    fill: "black"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.61878,
    y: 4.40199,
    width: 144.446,
    height: 144.446,
    rx: 72.223,
    stroke: "white",
    strokeWidth: 4.44603
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8455_31651",
    x1: 103.506,
    y1: 133.046,
    x2: 49.2489,
    y2: 48.1469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.7e-7,
    stopColor: "#FFD2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA4A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8455_31651",
    x1: 91.8127,
    y1: 121.806,
    x2: 65.1416,
    y2: 108.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.7e-7,
    stopColor: "#FFD2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA4A4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfileImg);
export default __webpack_public_path__ + "static/media/default_profile_img.445af9703a6e28bf785f35a1ffb445ce.svg";
export { ForwardRef as ReactComponent };